var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const defaultReducerState = {
  managementGroups: {
    data: [],
    error: "",
    isLoading: false
  }
};
const loadAllMgactionTypesPrefix = "loadAllManagementGroups";
const loadAllManagementGroupsActionTypes = {
  LOAD: `${loadAllMgactionTypesPrefix}/LOAD`,
  LOADING: `${loadAllMgactionTypesPrefix}/LOADING`,
  LOADED: `${loadAllMgactionTypesPrefix}/LOADED`
};
const loadAllManagementGroupsAction = (workspaceId) => {
  return {
    type: loadAllManagementGroupsActionTypes.LOAD,
    workspaceId
  };
};
const loadingAllManagementGroupsAction = () => {
  return {
    type: loadAllManagementGroupsActionTypes.LOADING
  };
};
const loadedAllManagementGroupsAction = (managementGroups) => {
  return {
    type: loadAllManagementGroupsActionTypes.LOADED,
    payload: managementGroups
  };
};
const managementGroupSelectorReducer = (state = defaultReducerState, action) => {
  var _a, _b;
  switch (action.type) {
    case loadAllManagementGroupsActionTypes.LOADING:
      return __spreadProps(__spreadValues({}, state), {
        managementGroups: __spreadProps(__spreadValues({}, state.managementGroups), {
          isLoading: true
        })
      });
    case loadAllManagementGroupsActionTypes.LOADED:
      return __spreadProps(__spreadValues({}, state), {
        managementGroups: {
          isLoading: false,
          data: ((_a = action.payload) == null ? void 0 : _a.data) || [],
          error: ((_b = action.payload) == null ? void 0 : _b.error) || ""
        }
      });
    default:
      return state;
  }
};
export {
  managementGroupSelectorReducer as default,
  defaultReducerState,
  loadAllManagementGroupsAction,
  loadAllManagementGroupsActionTypes,
  loadedAllManagementGroupsAction,
  loadingAllManagementGroupsAction,
  managementGroupSelectorReducer
};
//# sourceMappingURL=ManagementGroupSelector.ducks.js.map
